import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button } from 'transfix-ui/components/Button'
import { makeStyles, Typography } from 'transfix-ui/core'
import { autoConfirmStop } from 'utils/actions/shipmentStop'
import { scheduleActionsSelector } from 'apps/schedule/utils/selectors/scheduleActions'
import { IStop } from 'apps/schedule/utils/types/stops'
import { preferredSchedulingHours } from 'constants/facilities'

export interface ITimeButtonListProps {
  stop: IStop
  stopType: NonNullable<IStop['stopType']>
}

const useTimeButtonListStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  button: {
    padding: theme.spacing(2),
  },
  listContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(6, 1fr)',
    },
  },
}))

export const TimeButtonList = React.memo(({ stop, stopType }: ITimeButtonListProps) => {
  const styles = useTimeButtonListStyles()
  const state = useSelector(scheduleActionsSelector)
  const { submitting } = state
  const dispatch = useDispatch()

  return (
    <div className={styles.container}>
      <Typography variant='subtitle2' color='textSecondary'>
        Click an option to confirm
      </Typography>
      <div className={styles.listContainer}>
        {preferredSchedulingHours[stopType].map(hour => {
          const { autoConfirmToken, stopId, timezone } = stop
          const confirmStop = () => {
            dispatch(autoConfirmStop(stopId, autoConfirmToken, hour))
          }
          const key = `${stopId}-${hour}`
          return (
            <Button
              className={styles.button}
              color='secondary'
              onClick={confirmStop}
              size='xlarge'
              key={key}
              data-test={key}
              disabled={submitting}>
              {hour} {timezone}
            </Button>
          )
        })}
      </div>
    </div>
  )
})
